import React from 'react';
import styled from '@emotion/styled';
import { NavCard } from '../simba-cards';
import { InternalLinkType } from '../../../../types/internalLinkType';
import { useDocumentUrlWithNode } from '../../hooks/Documents/useDocumentUrl';
import { ExternalLinkType } from '../../../../types/externalLinkType';

type Props = {
  card: {
    title: string;
    ingress: string;
    externalLink: {
      data: ExternalLinkType;
    };
    internalLink: { data: InternalLinkType };
  };
};

const NafLocalEntryCard = ({ card: { internalLink, externalLink, ingress, title } }: Props) => {
  const internalItemUrl = useDocumentUrlWithNode(internalLink?.data);

  if (!internalItemUrl && !externalLink?.data?.href) {
    return <StyledSimpleCard title={title} description={ingress} />;
  }

  if (internalItemUrl) {
    return <StyledSimpleCard title={title} description={ingress} href={internalItemUrl} />;
  }

  return (
    <StyledSimpleCard
      title={title}
      description={ingress}
      href={externalLink?.data?.href}
      target="_blank"
      rel="noopener noreferrer"
    />
  );
};

const StyledSimpleCard = styled(NavCard)`
  && {
    width: 100%;
    height: 100%;
  }
`;

export default NafLocalEntryCard;
